/**
 * 表单匹配项
 */
<template>
  <div class="form-item">
    <el-input
      v-if="isInput"
      v-model.trim="currentVal"
      v-bind="bindProps"
      size="mini"
      :type="inputType"
      :placeholder="hasPlaceholder"
      :row="2"
      :disabled="isDisabled"
      :readonly="isReadonly"
      :class="{'readCss': itemOptions.readonly === 'readonly'}"
      v-on="bindEvents"
    />

    <el-input-number
      v-if="isInputNumber"
      v-model="currentVal"
      v-bind="bindProps"
      :controls-position="itemOptions['controls-position'] || 'right'"
      size="mini"
      v-on="bindEvents"
    />

    <!-- TODO 用slot代替固定组件 -->
    <div v-if="isInputWithBtn" class="input-with-btn">
      <el-input
        v-model="currentVal"
        v-bind="bindProps"
        size="mini"
        :type="itemOptions.inputType || null"
        v-on="bindEvents"
      />
      <el-button class="inputBtn orangeFont" v-on="bindEvents">{{ itemOptions.btnName }}</el-button>
    </div>

    <el-select
      v-if="isSelect"
      v-model="currentVal"
      v-bind="bindProps"
      :disabled="isDisabled"
      :placeholder="hasPlaceholder"
      size="mini"
      v-on="bindEvents"
    >
      <el-option
        v-for="item in itemOptions.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <el-dropdown
      v-if="isDropdown"
      ref="dropdowns"
      v-model="currentVal"
      v-bind="bindProps"
      size="mini"
      clearable
      v-on="bindEvents"
    >
      <span class="el-dropdown-link">
        {{ itemOptions.dropdownName }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div>
          <el-dropdown-item
            v-for="(item, index) in itemOptions.options"
            :key="`${index}-${item.value}`"
            :command="item.value"
          >{{ item.label }}</el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-radio-group v-if="isRadio" v-model="currentVal" size="mini" v-bind="bindProps" :disabled="isDisabled" v-on="bindEvents">
      <el-radio v-for="(item, index) in itemOptions.options" :key="`${index}-${item.value}`" :label="item.value">{{ item.label }}</el-radio>
    </el-radio-group>

    <div v-if="isSimuRadio">
      <div v-for="(item, index) in itemOptions.options" :key="`${index}-${item.value}`">
        <div class="asTitle">{{ item.name }}</div>
        <el-radio v-for="(x, xindex) in item.children" :key="`${xindex}-${x.value}`" v-model="currentVal" v-bind="bindProps" :disabled="isDisabled" :label="x.value" v-on="bindEvents">{{ x.name }}</el-radio>
      </div>
    </div>

    <el-checkbox-group v-if="isCheckbox" v-model="currentVal" size="mini" v-bind="bindProps" v-on="bindEvents">
      <el-checkbox v-for="(item, index) in itemOptions.options" :key="`${index}-${item.value}`" :label="item.value">{{ item.label }}</el-checkbox>
    </el-checkbox-group>

    <!-- datetimerange/daterange
    :key="currentVal[0] || Math.random()"
    -->
    <el-date-picker
      v-if="isDatePickerDateRange"
      v-model="currentVal"
      v-bind="bindProps"
      :type="itemOptions.type || 'datetimerange'"
      size="mini"
      clearable
      :picker-options="itemOptions.pickerOpts || pickerOptionsRange"
      :start-placeholder="$t('开始日期')"
      :range-separator="$t('至')"
      :end-placeholder="$t('结束日期')"
      :default-time="['00:00:00', '23:59:59']"
      value-format="yyyy-MM-dd HH:mm:ss"
      v-on="bindEvents"
    />

    <!-- monthrange -->
    <el-date-picker
      v-if="isDatePickerMonthRange"
      v-model="currentVal"
      v-bind="bindProps"
      type="monthrange"
      size="mini"
      clearable
      :picker-options="itemOptions.pickerOpts || pickerOptionsRangeMonth"
      :start-placeholder="$t('开始日期')"
      :range-separator="$t('至')"
      :end-placeholder="$t('结束日期')"
      :default-time="itemOptions.defaultTime || ['00:00:00', '23:59:59']"
      value-format="yyyy-MM"
      v-on="bindEvents"
    />

    <!-- others -->
    <el-date-picker
      v-if="isDatePickerOthers"
      v-model="currentVal"
      v-bind="bindProps"
      :type="itemOptions.type"
      size="mini"
      clearable
      :default-time="itemOptions.defaultTime || ['00:00:00', '23:59:59']"
      :placeholder="$t('请选择日期')"
      v-on="bindEvents"
    />

    <el-cascader
      v-if="isCascader"
      :key="hasKey"
      v-model="currentVal"
      v-bind="bindProps"
      size="mini"
      :options="itemOptions.options"
      clearable
      :props="itemOptions.casProps"
      :filterable="itemOptions.casFilter"
      :placeholder="hasPlaceholder"
      v-on="bindEvents"
    />

    <el-switch
      v-if="isSwitch"
      v-model="currentVal"
      active-color="#409EFF"
      inactive-color="#8cc5ff"
      :active-value="itemOptions.activeVal"
      :inactive-value="itemOptions.inactiveVal"
      v-on="bindEvents"
    />

    <div v-if="isSwitchNradio" class="switchNradio">
      <div>
        <!--
          1   :disabled="parseInt(itemOptions.switchValue) <= 100 && switchVal === parseInt(itemOptions.switchValue)"
          2   :disabled="parseInt(itemOptions.switchValue) <= 100 && switchVal === 'on'"
         -->
        <el-input
          v-model.trim="currentVal"
          v-bind="bindProps"
          size="mini"
          :placeholder="hasPlaceholder"
          :row="2"
          :disabled="itemOptions.switchValue === 'on'"
          class="inputSwitch"
          :class="{'readCss': itemOptions.readonly === 'readonly'}"
          @input="bindEvents['input']"
        />
        <!--
          :active-value="parseInt(itemOptions.switchValue)"
          :inactive-value="parseInt(itemOptions.switchValue) - 100"
         -->
        <el-switch
          v-model="itemOptions.switchValue"
          inactive-color="#909399"
          active-value="on"
          inactive-value="off"
          :disabled="isDisabled"
          v-on="bindEvents"
        />
      </div>
      <!-- <div v-show="parseInt(itemOptions.switchValue) >= 100 && switchVal === parseInt(itemOptions.switchValue)"> -->
      <!-- <div v-show="parseInt(itemOptions.switchValue) >= 100 && switchVal === 'on'"> -->
      <div v-if="itemOptions.switchValue !== 'off'">
        <el-radio-group v-model="currentVal" size="mini" v-bind="bindProps" v-on="bindEvents">
          <el-radio v-for="item in itemOptions.options" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-if="isSwitchNinput" class="switchNradio">
      <div>
        <!--
          1   :disabled="parseInt(itemOptions.switchValue) <= 100 && switchVal === parseInt(itemOptions.switchValue)"
          2   :disabled="parseInt(itemOptions.switchValue) <= 100 && switchVal === 'on'"
         -->
        <el-input
          v-model.trim="currentVal"
          v-bind="bindProps"
          size="mini"
          :placeholder="hasPlaceholder"
          :row="2"
          class="inputSwitch"
          :disabled="itemOptions.switchValue === 'on'"
          :class="{'readCss': itemOptions.readonly === 'readonly'}"
          @input="bindEvents['input']"
        />
        <!--
          :active-value="parseInt(itemOptions.switchValue)"
          :inactive-value="parseInt(itemOptions.switchValue) - 100"
         -->
        <el-switch
          v-model="itemOptions.switchValue"
          inactive-color="#909399"
          active-value="on"
          inactive-value="off"
          v-on="bindEvents"
        />
      </div>
    </div>
    <div v-if="isSwitchR" class="switchNradio">
      <div>
        <!--
          1   :disabled="parseInt(itemOptions.switchValue) <= 100 && switchVal === parseInt(itemOptions.switchValue)"
          2   :disabled="parseInt(itemOptions.switchValue) <= 100 && switchVal === 'on'"
         -->
        <!--
          :active-value="parseInt(itemOptions.switchValue)"
          :inactive-value="parseInt(itemOptions.switchValue) - 100"
         -->
        <el-switch
          v-model="itemOptions.switchValue"
          inactive-color="#909399"
          active-value="on"
          inactive-value="off"
          v-on="bindEvents"
        />
      </div>
      <!-- <div v-show="parseInt(itemOptions.switchValue) >= 100 && switchVal === parseInt(itemOptions.switchValue)"> -->
      <!-- <div v-show="parseInt(itemOptions.switchValue) >= 100 && switchVal === 'on'"> -->
      <div>
        <el-radio-group v-model="currentVal" size="mini" v-bind="bindProps" :disabled="itemOptions.switchValue === 'on'" v-on="bindEvents">
          <el-radio v-for="item in itemOptions.options" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { pickerOptionsRange, pickerOptionsRangeMonth } from '@klinx/utils/tool'
import { mapState } from 'vuex'
export default {
  components: {},
  inheritAttrs: false,
  props: {
    value: {},
    itemOptions: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      switchVal: 2,
      pickerOptionsRange: pickerOptionsRange,
      pickerOptionsRangeMonth: pickerOptionsRangeMonth
    }
  },
  computed: {
    // 双向绑定数据值
    currentVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    // 绑定属性
    bindProps() {
      const obj = { ...this.itemOptions }
      // 移除冗余属性
      delete obj.label
      delete obj.prop
      delete obj.element
      // delete obj.initValue
      delete obj.rules
      delete obj.events
      if (obj.element === 'el-select') {
        delete obj.options
      }
      return obj
    },
    // 绑定方法
    bindEvents() {
      return this.itemOptions.events || {}
    },
    // el-input
    isInput() {
      return this.itemOptions.element === 'el-input'
    },
    isSearchInput() {
      return this.itemOptions.element === 'el-input-search'
    },
    // textarea
    inputType() {
      if (this.itemOptions.element === 'el-input' && this.itemOptions.inputType === 'textarea') {
        return 'textarea'
      } else if (this.itemOptions.element === 'el-input' && this.itemOptions.inputType === 'password') {
        return 'password'
      } else {
        return 'input'
      }
      
    },
    // el-input-number
    isInputNumber() {
      return this.itemOptions.element === 'el-input-number'
    },
    // el-select
    isSelect() {
      return this.itemOptions.element === 'el-select'
    },
    isDropdown() {
      return this.itemOptions.element === 'el-dropdown'
    },
    // el-date-picker (type: datetimerange/daterange)
    isDatePickerDateRange() {
      const isDatePicker = this.itemOptions.element === 'el-date-picker'
      const isDateRange = !this.itemOptions.type ||
        this.itemOptions.type === 'datetimerange' ||
        this.itemOptions.type === 'daterange'
      return isDatePicker && isDateRange
    },
    // el-date-picker (type: monthrange)
    isDatePickerMonthRange() {
      const isDatePicker = this.itemOptions.element === 'el-date-picker'
      const isMonthRange = this.itemOptions.type === 'monthrange'
      return isDatePicker && isMonthRange
    },
    //  el-date-picker (type: other)
    isDatePickerOthers() {
      const isDatePicker = this.itemOptions.element === 'el-date-picker'
      return isDatePicker && !this.isDatePickerDateRange && !this.isDatePickerMonthRange
    },
    isSwitch() {
      return this.itemOptions.element === 'el-switch'
    },
    isSwitchNradio() {
      return this.itemOptions.element === 'el-switch-radio'
    },
    isSwitchNinput() {
      return this.itemOptions.element === 'el-switch-input'
    },
    isSwitchR() {
      return this.itemOptions.element === 'el-switch-r'
    },
    // el-cascader
    isCascader() {
      return this.itemOptions.element === 'el-cascader'
    },
    hasKey() {
      return this.itemOptions.key
    },
    isInputWithBtn() {
      return this.itemOptions.element === 'inputWithBtn'
    },
    isDisabled() {
      return this.itemOptions.disable === 'disabled' || this.itemOptions.disable === true;
    },
    isReadonly() {
      return this.itemOptions.readonly === 'readonly' || this.itemOptions.readonly === true;
    },
    isRadio() {
      return this.itemOptions.element === 'el-radio'
    },
    isSimuRadio() {
      return this.itemOptions.element === 'el-radio-groups'
    },
    isCheckbox() {
      return this.itemOptions.element === 'el-checkbox'
    },
    hasPlaceholder() {
      return this.itemOptions.placeholder
    },
    hasSize() {
      return this.itemOptions.size
    }
  },

  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang='less' scoped>

.readCss{
  ::v-deep .el-input__inner{
    border:1px solid transparent !important;
    padding: 0 !important;
  }
}

.el-radio-group{
  width:200px;
  text-align:left;
}

.input-with-btn{
  display: inline-block;
  vertical-align: middle;
  width: 200px;
  > .el-input:not(.el-date-editor) {
    width: 130px;
    float:left;
    ::v-deep .el-input__inner {
      height:36px;
      line-height:36px;
    }
  }
  .el-button {
    float:left;
    background-color: transparent;
    width:60px;
    height:35px;
    color:#409EFF;
    border-radius: 0;
    border:none;
    padding:0;
    margin-left:10px;
  }
}

.switchNradio{
  width:100%;
  ::v-deep .inputSwitch{
    width:80% !important;
    display: inline-block;
    vertical-align:top;
    margin-right:12px;
    margin-bottom:12px;
    .el-input__inner{
      height:32px;
      line-height:32px;
    }
  }
}

</style>
